import { clsx, type ClassValue } from "clsx";

/**
 * Classname helper without tailwind-merge (~100KB). Site classes are authored
 * without conflicting utilities, so merge is unused cost on the homepage.
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
